import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./propertydetailsMovedDialog.component.html')
})
export class PropertydetailsMovedDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<PropertydetailsMovedDialog>) public dialogRef: MatDialogRef<PropertydetailsMovedDialog>) {}

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
